var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import api from '@utils/axios';
/**
 * `useDirectUpload`'s transport for inspection attachments.
 *
 * Deliberately the raw `@utils/axios` client, NOT `@utils/api-client` — that one's
 * axios-case-converter middleware would camelCase this endpoint's response (`signed_id` ->
 * `signedId`) and the hook expects the wire shapes verbatim, snake_case included. Mirrors
 * `BuildingAttachments/services/directUploadTransport.ts` for the same reason.
 */
export function createDirectUploadTransport(inspectionId) {
    const base = `/api/internal/inspections/${inspectionId}/attachment_uploads`;
    return {
        presign: (request, signal) => __awaiter(this, void 0, void 0, function* () {
            const response = yield api.post(base, request, { signal });
            return response.data;
        }),
        // Rooted at `inspection_attachments` on the wire (see the controller's `response_root`); the
        // hook consumes a normalised `attachments`.
        finalize: (request, signal) => __awaiter(this, void 0, void 0, function* () {
            const response = yield api.post(`${base}/finalize`, request, { signal });
            return { attachments: response.data.inspection_attachments };
        })
    };
}
